export {default as quadtree} from "./src/quadtree";



//////////////////
// WEBPACK FOOTER
// /srv/scratch/old-home/dyall/trinity/trinity-frontend-master/~/d3-quadtree/index.js
// module id = ../../../../d3-quadtree/index.js
// module chunks = 3